import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cd3f0c48")

_pushScopeId("data-v-cd3f0c48")
const _hoisted_1 = { class: "settings-row" }
const _hoisted_2 = { class: "input-box" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "Size", -1)
const _hoisted_4 = { class: "settings-row" }
const _hoisted_5 = { class: "input-box" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "Font", -1)
const _hoisted_7 = { class: "settings-row" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("input", {
          type: "number",
          value: _ctx.size,
          onInput: _cache[1] || (_cache[1] = $event => (_ctx.$emit('update:size', Number($event.target.value))))
        }, null, 40, ["value"]),
        _hoisted_3
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("select", {
          value: _ctx.font,
          onInput: _cache[2] || (_cache[2] = $event => (_ctx.$emit('update:font', $event.target.value)))
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.regFonts, (font) => {
            return (_openBlock(), _createBlock("option", {
              style: { fontFamily: font },
              key: font,
              value: font
            }, _toDisplayString(font), 13, ["value"]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 40, ["value"]),
        _hoisted_6
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("a", {
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.triggerFileSelector()))
      }, "Upload custom font"),
      _createVNode("input", {
        type: "file",
        ref: "fileDownload",
        accept: ".ttf",
        style: {"display":"none"},
        onChange: _cache[4] || (_cache[4] = $event => (_ctx.checkForUpload()))
      }, null, 544)
    ])
  ], 64 /* STABLE_FRAGMENT */))
})